import { useEffect, useState } from "react"
import AddRubbersaplings from "./AddRubbersaplings"
import { PlantDistanceDDL } from "../../../../CommonDDL/PlantDistanceDDL";
import { LandUsedForRubberPlantationDDL } from "../../../../CommonDDL/LandUsedForRubberPlantationDDL";
import { LandOwnershipDDL } from "../../../../CommonDDL/LandOwnershipDDL";
import { LandPreparationIdDDL } from "../../../../CommonDDL/LandPreparationIdDDL";
import { MonthDDL } from "../../../../CommonDDL/MonthDDL";
import { PlantationDetailsPartThreePatchAPI, PlantationDetailsPartThreeTableDataAPI, RubberSaplingsDeleteAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import StatusOfIntercrops from "./StatusOfIntercrops";
import OtherInsertSection from "../OtherInsertSection";
import { CommonCircle } from "../CommonCircle";
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp";
import { AstricSign } from "../../../../../Helper/AstricSign";


const PartThirdPopup = (props) => {

    const { handleShowAddModal, ShowAddModal, Title, handleIsPost, YearValue, MonthValue } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [RubbersaplingsPopup, setRubbersaplingsPopup] = useState(false)

    const [PlantationDetails, setPlantationDetails] = useState([])
    const [RubberSaplingData, setRubberSaplingData] = useState([])

    const [ChallengesInRubberPlantation, setChallengesInRubberPlantation] = useState('')
    const [DataIsPost, setDataIsPost] = useState(false)
    const [IsOthersData, setIsOthersData] = useState('')

    const [MonthDDLID, setMonthDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [PlantdistancesId, setPlantdistancesId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [StatusOfIntercropsId, setStatusOfIntercropsId] = useState({
        DDL: [],
        ID: flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.statusOfIntercrops_M_IndicatorID : 0,
        Label: flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.statusOfIntercrops_M_Indicator : "Select...",
    })

    const [LandUsedForRubberPlantationId, setLandUsedForRubberPlantationId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [LandOwnershipId, setLandOwnershipId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [LandPreparationId, setLandPreparationId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })

    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleAddrubbersaplings = () => {
        setRubbersaplingsPopup(!RubbersaplingsPopup)
    }

    const handleDeleteDataIsPost = () => {
        setDataIsPost(!DataIsPost)
        // handleAddrubbersaplings()
        handleShowDelete()
    }

    useEffect(() => {
        const data = {
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            T_BeneficiaryPlantationDetailsID: 0,
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationPart3",
            token: token,
            setPlantationDetails: setPlantationDetails,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

        }

    }, [YearValue, MonthValue])

    useEffect(() => {
        const data = {
            FinancialYearID: 0,
            MonthID: 0,
            T_BeneficiaryPlantationDetailsID: PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID : 0,
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "AddPlaningTime",
            token: token,
            setRubberSaplingData: setRubberSaplingData,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

        }

    }, [YearValue, MonthValue,DataIsPost])


    const { isLoading } = useSelector(state => state.PlantationDetailsPartThreeTableData)

    useEffect(() => {

        setChallengesInRubberPlantation(flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.challengesInPlantation : '')

    }, [PlantationDetails])

    const handleUpdate = () => {

        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            // T_BeneficiaryPlantationDetailsID: PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID,
            T_BeneficiaryPlantationDetailsID: 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            PlanDistance_M_IndicatorID: PlantdistancesId.ID,
            RubberPlants_M_IndicatorID: MonthDDLID.ID,
            ChallengesInPlantation: ChallengesInRubberPlantation,
            StatusOfIntercrops_M_IndicatorID: StatusOfIntercropsId.ID,
            StatusOfLand_M_IndicatorID: LandUsedForRubberPlantationId.ID,
            LandOwnership_M_IndicatorID: LandOwnershipId.ID,
            LandPreparation_M_IndicatorID: LandPreparationId.ID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost
        }
        dispatch(PlantationDetailsPartThreePatchAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantationDetailsPartTwoPostData)

    const handleDeleteData = () => {

        const data = {
            T_BeneficiaryPlantationDetails_AddPlaningTimeID: ShowDeletePopupData?.t_BeneficiaryPlantationDetails_AddPlaningTimeID,
            M_TableUserMasterID: UserID,
            token: token,
            handleDeleteDataIsPost
        }
        dispatch(RubberSaplingsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.RubberSaplingsDeleteData)

    return (
        <>
            {isLoading ? <Loading /> :
                <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                    <div className="modal-dialog modal-lg " style={{ minWidth: '40vw' }} role="document"  >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                                <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'scroll', height: '80vh' }}>
                                <div className="row">
                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        {/* <span className="fw-bold ">Plant to plant distances : </span> */}

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <PlantDistanceDDL
                                                    PlantdistancesId={PlantdistancesId}
                                                    setPlantdistancesId={setPlantdistancesId}
                                                    apiFlag='DistanceMaintained'
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost={IsOthersData}
                                                    AstricSignFlag="AstricSign"
                                                />

                                            </div>
                                        </div>
                                        {
                                            PlantdistancesId.ID == 5 &&
                                            <OtherInsertSection
                                                Flag='DistanceMaintained'
                                                IsOthersData={IsOthersData}
                                                setIsOthersData={setIsOthersData}

                                            />
                                        }



                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">What is the right season for Plantation of rubber plants? <AstricSign /> : </span>

                                        <div className="row pt-2">
                                            <div className="col-12 col-lg-8">
                                                <MonthDDL
                                                    MonthDDLID={MonthDDLID}
                                                    setMonthDDLID={setMonthDDLID}
                                                    apiFlag=''
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost=''
                                                    MonthDDLFlag="MonthDDLFlag"
                                                    AstricSignFlag="AstricSign"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-4 border-bottom">
                                        <CommonCircle />
                                        <span className="">When did you plant the rubber saplings <AstricSign /> : </span>

                                        <span className=" add_button mx-3 px-3 py-1"
                                            onClick={() => handleAddrubbersaplings()}
                                        >
                                            <i class="fa-solid fa-plus"></i>  Add
                                        </span>

                                        <div className="table-responsive p-0 pt-2" >
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr className=" text-white">
                                                        <th className="text-center">Sr. No.</th>
                                                        <th className="text-center">Year</th>
                                                        <th className="text-center">Month</th>
                                                        <th className="text-center">No Of Saplings</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {

                                                        RubberSaplingData && RubberSaplingData.length > 0 ? RubberSaplingData.map((i, j) => {
                                                            return (
                                                                <>

                                                                    <tr>
                                                                        <td align="center">{j + 1}</td>
                                                                        <td>{i.financialYearID ? i.financialYearID : '-'}</td>
                                                                        <td>{i.monthsName ? i.monthsName : '-'}</td>
                                                                        <td>{i.noOfPlants ? i.noOfPlants : '-'}</td>
                                                                        <td align="center">

                                                                            <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                                onClick={() => handleShowDelete(i)}
                                                                                title="Do you want to delete this record?"></i>
                                                                        </td>

                                                                    </tr>


                                                                </>

                                                            )
                                                        })
                                                            :
                                                            <>No data found</>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>

                                        <div className="col-12 col-lg-6 pt-2">
                                            <CommonCircle />
                                            <span className="">Challenges in rubber plantation <AstricSign /> : </span>
                                            <input
                                                type="text"
                                                className="form-control mt-2 "
                                                name="ChallengesInRubberPlantation"
                                                placeholder="type here"
                                                value={ChallengesInRubberPlantation}
                                                onChange={(e) => setChallengesInRubberPlantation(e.target.value)}

                                            />
                                        </div>

                                        <StatusOfIntercrops
                                            M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                            T_BeneficiaryPlantationDetailsID={PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                            StatusOfIntercropsId={StatusOfIntercropsId}
                                            setStatusOfIntercropsId={setStatusOfIntercropsId}
                                            Flag={flag}
                                            data={PlantationDetails && PlantationDetails[0]}
                                            PlantdistancesId={PlantdistancesId}

                                        />
                                    </div>


                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">Status of land used for rubber plantation <AstricSign /> : </span>

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <LandUsedForRubberPlantationDDL
                                                    LandUsedForRubberPlantationId={LandUsedForRubberPlantationId}
                                                    setLandUsedForRubberPlantationId={setLandUsedForRubberPlantationId}
                                                    apiFlag='LandUsedForRubberPlantation'
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost=''
                                                    AstricSignFlag="AstricSign"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">Land Ownership <AstricSign /> : </span>

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <LandOwnershipDDL
                                                    LandOwnershipId={LandOwnershipId}
                                                    setLandOwnershipId={setLandOwnershipId}
                                                    apiFlag='Ownership'
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost={IsOthersData}
                                                />
                                            </div>

                                        </div>
                                        {
                                            LandOwnershipId.ID == 5 &&
                                            <OtherInsertSection
                                                Flag='Ownership'
                                                IsOthersData={IsOthersData}
                                                setIsOthersData={setIsOthersData}

                                            />
                                        }
                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-3">
                                        <CommonCircle />
                                        <span className="">Management practice for land preparation <AstricSign /> : </span>

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <LandPreparationIdDDL
                                                    LandPreparationId={LandPreparationId}
                                                    setLandPreparationId={setLandPreparationId}
                                                    apiFlag='LandPreparation'
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost={IsOthersData}
                                                />
                                            </div>

                                        </div>
                                        {
                                            LandPreparationId.ID == 4 &&
                                            <OtherInsertSection
                                                Flag='LandPreparation'
                                                IsOthersData={IsOthersData}
                                                setIsOthersData={setIsOthersData}

                                            />
                                        }
                                    </div>

                                    <div className="col-12 pt-5 ">
                                        <div className="form-group w-80 d-flex justify-content-center">
                                            <button
                                                type='button'
                                                onClick={handleUpdate}
                                                disabled={PlantdistancesId.ID == 0 || MonthDDLID.ID == 0 || ChallengesInRubberPlantation == '' ||
                                                    LandUsedForRubberPlantationId.ID == 0 || LandOwnershipId.ID == 0 || LandPreparationId.ID == 0 || StatusOfIntercropsId.ID == 0}
                                                className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                                Update
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleShowAddModal(false, '')}
                                                className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div >
            }


            {
                RubbersaplingsPopup &&
                <AddRubbersaplings
                    handleAddrubbersaplings={handleAddrubbersaplings}
                    Title='Add Planting Time'
                    M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                    T_BeneficiaryPlantationDetailsID={PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID : 0}
                    DataIsPost={DataIsPost}
                    setDataIsPost={setDataIsPost}

                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }


        </>);
}

export default PartThirdPopup;